


























import { SessionTypeEnum } from '@api/enums/Session/SessionTypeEnum';
import { getImageUrl } from '@common/ImageUrlHelper';
import { isShowLiveBadge } from '@common/AgendaHelper';
import {Component, Prop, Watch} from 'vue-property-decorator';
import { Element } from "@api/models/Element"

import QaIcon from "../../../../../assets/svg/qa-session-icon.svg";
import FavoritesSwitcher from "@share/common/favorites-switcher/FavoritesSwitcher.vue";
import {isObjectInFavoritesGetter} from "@service/store/favorites/getters";
import {Debounce} from "vue-debounce-decorator";
import {addToFavoriteAction, removeFromFavoriteAction} from "@service/store/favorites/actions";
import TimeCardTopBase from '@share/common/cards/time-card/components/top/TimeCardTopBase.vue';

@Component({
    components: {FavoritesSwitcher, QaIcon }
})
export default class SessionCardTop extends TimeCardTopBase {

    @Prop({ required: true }) declare source: Element;
    @Prop() partner: Element | undefined;

    isFavorite = false;
    schemaId = process.env.VUE_APP_AGENDA_SCHEMA as string;

    created() {
        this.setIsFavorite();
    }

    setIsFavorite() {
        const isFaveValue = this.isFavoriteFromState;
        if (isFaveValue != this.isFavorite) {
            this.isFavorite = isFaveValue;
        }
    }

    get showIsLive() {
        return isShowLiveBadge(this.source);
    }

    get partnerIconUrl() {
        return getImageUrl(this.$route.params.backend, this.partner?.iconFileId, 109)
    }

    get partnerId() {
        return this.partner?.id
    }

    get partnerTitle() {
        return this.partner?.title
    }

    get isSession() {
        return this.sessionType === SessionTypeEnum.session
    }

    get isRoundTable() {
        return this.sessionType === SessionTypeEnum.roundtable;
    }

    get isQA() {
        return this.sessionType === SessionTypeEnum.speakersQA
    }

    get sessionType(): SessionTypeEnum {
        return this.source.type;
    }

    get eventLogoUrl() {
        const event = this.$store.getters['events/selectedEvent'];

        return getImageUrl(this.$route.params.backend, event?.imageFileId, 200);
    }

    get isFavoriteFromState() {
        return this.$store.getters[isObjectInFavoritesGetter](this.schemaId, this.source.id);
    }

    @Watch('isFavoriteFromState')
    onFavoritesListChanged() {
        this.setIsFavorite();
    }

    @Debounce(350)
    async onFaveChanged(value: boolean) {
        await this.$store.dispatch(this.isFavorite ? addToFavoriteAction : removeFromFavoriteAction, {
            schemaId: this.schemaId,
            objectId: this.source.id
        });
    }
}

